import { CHECK_IN_APT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export default async function checkInAppointment(
    aid: string,
): Promise<{ success: boolean; error?: string; data: TrystTransaction }> {
    const response = await fetchWithRefresh(CHECK_IN_APT(aid), {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            mode: 'cors',
            credentials: 'include',
        },
    });

    const res = await response.json();
    return res;
}

export type TrystTransaction = {
    date: string;
    doctor_oid: string;
    aid: string;
    patient_uuid: string | null;
    patient_oid: string | null;
    clinic_id: string;
    channel: string | null;
    onsched_id: string | null;
    status: string | null;
    start_time: string;
    end_time: string;
    visit_checkin: string | null;
    visit_start: string | null;
    visit_end: string | null;
    created_at: string | null;
    payment_id: string | null;
    payment_status: string | null;
    sa_id: string | null;
    tele_id: string | null;
    amount: number | null;
    prescription_id: string | null;
    follow_up: string | null;
    callback_requested: string | null;
    park_allowed: string | null;
    updated_at: string | null;
    call_status: string | null;
    patient_tele_status: string | null;
    doctor_tele_status: string | null;
    flavour: string | null;
    attribute: string | null;
    service: string | null;
    referral_id: string | null;
    visit_count: number | null;
    last_visit_time: string | null;
    archive: boolean | null;
    prescription_url: string | null;
    service_type: number | null;
    service_conf_id: string | null;
    mode: string | null;
    visit_type: 'FLW' | 'REG' | null;
    doc_dwr_link: string | null;
    phr_id: string | null;
    dwr_link: string | null;
    patient_profile: string | null;
    tags: string;
    token: number | null;
    comm_meta: string | null;
};
